import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import GlobalPlugin from './GlobalPlugin'
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
createApp(App).component('DatePicker', Vue3PersianDatetimePicker).use(store).use(GlobalPlugin).use(router).mount('#app')


